/* global axios */
import ApiClient from './ApiClient';

class BrandingSettingsAPI extends ApiClient {
  constructor() {
    super('branding_setting', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(formData) {
    return axios.patch(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteLogo() {
    return axios.delete(`${this.url}/logo`);
  }

  deleteFavicon() {
    return axios.delete(`${this.url}/favicon`);
  }
}

export default new BrandingSettingsAPI();
